import Parse from "parse";
import moment from "moment";
// import store from "@/store";
// const date = new Date();
// const y = date.getFullYear();
// const m = date.getMonth();
// const start = new Date(y, m, 1);
// const end = new Date(y, m + 3, 0);

const state = {
  instructorAppointments: null,
  studentAppointments: null,
  instructorPackages: null,
  appointments: null,
  studentAppointment: null,
  approveAppointment: null,
  completeAppointment: null,
  reviews: null,
  reviewRatings: null,
  checkReview: null,
  transferQ: null,
  declineAppment: null,
  rescheduleAppment: null,
  paymentHistory: null,
  rescheduleFromAdmin: null,
};

const getters = {
  instructorAppointments: (state) => state.instructorAppointments,
  studentAppointments: (state) => state.studentAppointments,
  instructorPackages: (state) => state.instructorPackages,
  appointments: (state) => state.appointments,
  studentAppointment: (state) => state.studentAppointment,
  approveAppointment: (state) => state.approveAppointment,
  completeAppointment: (state) => state.completeAppointment,
  reviews: (state) => state.reviews,
  reviewRatings: (state) => state.reviewRatings,
  checkReview: (state) => state.checkReview,
  transferQ: (state) => state.transferQ,
  declineAppment: (state) => state.declineAppment,
  rescheduleAppment: (state) => state.rescheduleAppment,
  paymentHistory: (state) => state.paymentHistory,
  rescheduleFromAdmin: (state) => state.rescheduleFromAdmin,
};

const actions = {
  /** Get Instructors appointments between given start and end date */
  async getInstructorAppointments({ commit }, payload) {
    const Appointments = Parse.Object.extend("Appointments");
    const query = new Parse.Query(Appointments);
    query.greaterThanOrEqualTo("start", payload.start);
    query.lessThanOrEqualTo("end", payload.end);
    query.include("studentId");
    query.include("instructorPackageId");
    query.include("schoolPackageId");
    query.include("schoolPackageId.schoolId.associatedId");

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.instructorId;
    query.equalTo("instructorId", UserPointerId);

    // filter by status (from search)
    if (payload.status && payload.status !== "All") {
      query.equalTo("status", payload.status);
    }

    // filter by location (appoinmentLocation)
    if (payload.location && payload.location.trim()) {
      query.contains("appoinmentLocation", payload.location.trim());
    }

    /** sort by createdAt, latest first */
    query.descending("createdAt");
    query.limit(payload.limit || 5);
    query.skip(payload.skip || 0);
    try {
      // When loading first page (not append), get total count with same filters (no name/email - those are in-memory)
      let total = null;
      if (!payload.append && !payload.searchText && !payload.searchType) {
        const countQuery = new Parse.Query(Appointments);
        countQuery.greaterThanOrEqualTo("start", payload.start);
        countQuery.lessThanOrEqualTo("end", payload.end);
        countQuery.equalTo("instructorId", UserPointerId);
        if (payload.status && payload.status !== "All") {
          countQuery.equalTo("status", payload.status);
        }
        if (payload.location && payload.location.trim()) {
          countQuery.contains("appoinmentLocation", payload.location.trim());
        }
        total = await countQuery.count();
      }
      const response = await query.find();
      // filter by student name or email (Parse can't query relation fields, so filter after find)
      if (
        payload.searchText &&
        payload.searchText.trim() &&
        payload.searchType
      ) {
        const search = payload.searchText.trim().toLowerCase();
        if (payload.searchType === "name") {
          response = response.filter((app) => {
            const student = app.get("studentId");
            if (!student) return false;
            const name = `${student.get("firstName") || ""} ${
              student.get("lastName") || ""
            }`.toLowerCase();
            return name.includes(search);
          });
        } else if (payload.searchType === "email") {
          response = response.filter((app) => {
            const student = app.get("studentId");
            if (!student) return false;
            const email = (
              student.get("customEmail") ||
              student.get("email") ||
              ""
            ).toLowerCase();
            return email.includes(search);
          });
        }
      }
      const limit = payload.limit || 5;
      if (payload.append) {
        commit("appendInstructorAppointments", response);
      } else {
        commit("setInstructorAppointments", response);
      }
      return {
        results: response,
        hasMore: response.length >= limit,
        total,
      };
    } catch (error) {
      console.log(error);
      commit("setInstructorAppointments", []);
      return { results: [], hasMore: false, total: null };
    }
  },

  async getStudentAppointments({ commit }, payload) {
    const Appointments = Parse.Object.extend("Appointments");
    const query = new Parse.Query(Appointments);
    query.greaterThanOrEqualTo("start", payload.start);
    query.lessThanOrEqualTo("end", payload.end);
    query.include("instructorId");
    query.include("studentId");
    query.include("instructorPackageId");
    query.include("schoolPackageId.schoolId.associatedId");

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.studentId;
    query.equalTo("studentId", UserPointerId);
    // filter by status (from search)
    if (payload.status && payload.status !== "All") {
      query.equalTo("status", payload.status);
    }

    /** let's sort by start date */
    query.descending("createdAt");
    query.limit(payload.limit || 5);
    query.skip(payload.skip || 0);

    try {
      let total = null;
      if (!payload.append) {
        const countQuery = new Parse.Query(Appointments);
        countQuery.greaterThanOrEqualTo("start", payload.start);
        countQuery.lessThanOrEqualTo("end", payload.end);
        countQuery.equalTo("studentId", UserPointerId);
        if (payload.status && payload.status !== "All") {
          countQuery.equalTo("status", payload.status);
        }
        total = await countQuery.count();
      }
      const response = await query.find();
      const limit = payload.limit || 5;
      if (payload.append) {
        commit("appendStudentAppointments", response);
      } else {
        commit("setStudentAppointments", response);
      }
      return {
        results: response,
        hasMore: response.length >= limit,
        total,
      };
    } catch (error) {
      console.log(error);
      commit("setStudentAppointments", []);
      return { results: [], hasMore: false, total: null };
    }
  },

  async updateAppointment(payload) {
    const Appointments = Parse.Object.extend("Appointments");
    var updateAppointment = new Appointments();

    updateAppointment.id = payload.appointmentId;
    updateAppointment.set("status", payload.status);
    try {
      const response = updateAppointment.save();
      console.log(response);
    } catch (error) {
      return { status: true, title: "Error", message: error.message };
    }
  },
  async declineAppointment({ commit }, payload) {
    const Appointments = Parse.Object.extend("Appointments");
    var updateAppointment = new Appointments();

    updateAppointment.id = payload.appointmentId;
    updateAppointment.set("status", payload.status);
    try {
      const response = await updateAppointment.save();
      console.log(response);
      Parse.Cloud.run("declineEmail", {
        name: payload.appointmentName,
        instructorName: payload.instructorName,
        date: payload.start,
        email: payload.email,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          // The object was not retrieved successfully.
          // error is a Parse.Error with an error code and message.
          console.log(error);
        });
      commit("setDeclineEvent", true);
    } catch (error) {
      commit("setDeclineEvent", false);
    }
  },

  async rescheduleAppointment({ commit }, payload) {
    const Appointments = Parse.Object.extend("Appointments");
    var updateAppointment = new Appointments();
    updateAppointment.id = payload.appointmentId;
    await updateAppointment
      .destroy()
      .then(async () => {
        const data = {
          name: payload.name,
          senderName: payload.senderName,
          date: moment(payload.date).format("lll"),
          email: payload.email,
          note: payload.note,
        };
        await Parse.Cloud.run("declineEmail", data).then(
          (results) => {
            console.log(results);
          },
          (error) => {
            console.log(error);
          },
        );
        commit("setRescheduleEvent", true);
      })
      .catch((error) => {
        console.log(error);
        commit("setRescheduleEvent", false);
      });
  },

  async deleteAppointment(payload) {
    const Appointments = Parse.Object.extend("Appointments");
    var updateAppointment = new Appointments();
    updateAppointment.id = payload.appointmentId;
    try {
      const response = updateAppointment.destroy();
      console.log(response);
    } catch (error) {
      return { status: true, title: "Error", message: error.message };
    }
  },
  /** Get Instructors packages */
  async getInstructorPackages({ commit }, payload) {
    const InstructorPackages = Parse.Object.extend("InstructorPackages");
    const query = new Parse.Query(InstructorPackages);
    query.include("instructorId");
    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.instructorId;
    query.equalTo("instructorId", UserPointerId);
    try {
      const response = await query.first();
      console.log(response);
      commit("setInstructorPackages", response);
    } catch (error) {
      console.log(error);
      commit("setInstructorPackages", []);
    }
  },
  async updatePackage({ commit }, payload) {
    const InstructorPackages = Parse.Object.extend("InstructorPackages");
    var updateInstructorPackages = new InstructorPackages();
    if (payload.packageId) {
      updateInstructorPackages.id = payload.packageId;
    } else {
      const User = Parse.Object.extend("User");
      const UserPointerId = new User();
      UserPointerId.id = payload.instructorId;
      updateInstructorPackages.set("instructorId", UserPointerId);
    }
    updateInstructorPackages.set("booking_lesson", payload.booking_lesson);
    updateInstructorPackages.set("school_rate", payload.school_rate);
    updateInstructorPackages.set(
      "roadtest_rent_car",
      payload.roadtest_rent_car,
    );
    updateInstructorPackages.set("rentcar_n_lesson", payload.rentcar_n_lesson);
    try {
      const response = await updateInstructorPackages.save();
      console.log(JSON.stringify(response));
      commit("setInstructorPackages", response);
      return { status: true, title: "Success", response: response };
    } catch (error) {
      return { status: true, title: "Error", message: error.message };
    }
  },
  async saveCompleteAppointment({ commit }, payload) {
    const Appointments = Parse.Object.extend("Appointments");
    const updateAppointment = new Appointments();
    updateAppointment.id = payload.appointmentId;
    updateAppointment.set("status", payload.status);
    updateAppointment.set("paid", payload.paid);
    try {
      const response = await updateAppointment.save();
      commit("setCompleteAppointment", response);
    } catch (error) {
      commit("setCompleteAppointment", false);
    }
  },
  async saveStudentAppointment({ commit }, payload) {
    var drivingLessonDates = [];
    var start;
    var end = null;
    console.log(payload);
    if (payload.package === "booking_lesson") {
      drivingLessonDates = payload.selectedDateTimes;
      start = new Date(moment(payload.selectedDateTimes[0].start));
      /** additional 60 mins or 1 hr */
      end = new Date(moment(start).add(60, "minutes"));
    } else {
      start = new Date(moment(payload.selectedDateTimes.start));
      /** For all other cases, add extra 2 hr */
      end = new Date(moment(start).add(120, "minutes"));
    }
    const Appointments = Parse.Object.extend("Appointments");
    const saveStudentAppointment = new Appointments();

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.studentId;
    saveStudentAppointment.set("studentId", UserPointerId);
    saveStudentAppointment.set("appoinmentLocation", payload.studentAddress);

    const InstructorPointerId = new User();
    InstructorPointerId.id = payload.instructorId;
    saveStudentAppointment.set("instructorId", InstructorPointerId);

    const InstructorPackages = Parse.Object.extend("InstructorPackages");
    const InstructorPackagePointerId = new InstructorPackages();
    InstructorPackagePointerId.id = payload.instructorPackageId;
    saveStudentAppointment.set(
      "instructorPackageId",
      InstructorPackagePointerId,
    );

    if (
      typeof payload.schoolPackageId !== "undefined" &&
      payload.schoolPackageId !== ""
    ) {
      const SchoolPackages = Parse.Object.extend("SchoolPackages");
      const SchoolPackagesPointerId = new SchoolPackages();
      SchoolPackagesPointerId.id = payload.schoolPackageId;
      saveStudentAppointment.set("schoolPackageId", SchoolPackagesPointerId);
    }

    saveStudentAppointment.set("start", start);
    saveStudentAppointment.set("end", end);
    saveStudentAppointment.set("drivingLessonDates", drivingLessonDates);
    saveStudentAppointment.set("type", [payload.package]);

    saveStudentAppointment.set("parking", payload.parking);
    saveStudentAppointment.set("highwayDriving", payload.highwayDriving);
    saveStudentAppointment.set(
      "innerCityDrivingTurns",
      payload.innerCityDrivingTurns,
    );
    saveStudentAppointment.set("roadtestOptions", payload.roadtestOptions);
    saveStudentAppointment.set("notes", payload.notes);

    saveStudentAppointment.set("status", "Pending");

    /** For some weird reasons, data wouldn't save without the masterKey. MK is added to the parse init page */
    await saveStudentAppointment.save(null, { useMasterKey: true }).then(
      (saveStudentAppointment) => {
        console.log(saveStudentAppointment);
        commit("setStudentAppointment", saveStudentAppointment);
      },
      (error) => {
        console.log(error);
        commit("setStudentAppointment", false);
      },
    );
  },

  async checkReviewRatings({ commit }, payload) {
    const Reviews = Parse.Object.extend("Reviews");
    const query = new Parse.Query(Reviews);

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.reviewFrom;
    query.equalTo("reviewFrom", UserPointerId);

    const reviewForPointerId = new User();
    reviewForPointerId.id = payload.reviewFor;
    query.equalTo("reviewFor", reviewForPointerId);

    const Appointments = Parse.Object.extend("Appointments");
    const AppointmentPointerId = new Appointments();
    AppointmentPointerId.id = payload.appointmentId;
    query.equalTo("appointmentId", AppointmentPointerId);

    try {
      const response = await query.first();
      if (response) {
        commit("setCheckReview", response);
      } else {
        commit("setCheckReview", false);
      }
    } catch (error) {
      console.log(error);
      commit("setCheckReview", false);
    }
  },

  async saveReviewRatings({ commit }, payload) {
    const Reviews = Parse.Object.extend("Reviews");
    const saveReviews = new Reviews();

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.reviewFrom;
    saveReviews.set("reviewFrom", UserPointerId);

    const reviewForPointerId = new User();
    reviewForPointerId.id = payload.reviewFor;
    saveReviews.set("reviewFor", reviewForPointerId);

    if (payload.reviewId) {
      saveReviews.id = payload.reviewId;
    }
    if (payload.appointmentId) {
      const Appointments = Parse.Object.extend("Appointments");
      const AppointmentPointerId = new Appointments();
      AppointmentPointerId.id = payload.appointmentId;
      saveReviews.set("appointmentId", AppointmentPointerId);
    }
    saveReviews.set("star", payload.star);
    saveReviews.set("review", payload.review);
    if (payload.checklist) {
      saveReviews.set("checklist", payload.checklist);
    }
    if (payload.instructorSignature) {
      saveReviews.set("instructorSignature", payload.instructorSignature);
    }
    if (payload.studentSignature) {
      saveReviews.set("studentSignature", payload.studentSignature);
    }

    try {
      await saveReviews.save();
      if (payload.studentSignature && payload.appointmentId) {
        const Appointments = Parse.Object.extend("Appointments");
        const app = new Appointments();
        app.id = payload.appointmentId;
        app.set("studentSignature", payload.studentSignature);
        await app.save();
      }
      /** Find the total and avg */
      const Reviews = Parse.Object.extend("Reviews");
      const query = new Parse.Query(Reviews);

      const User = Parse.Object.extend("User");
      const UserPointerId = new User();

      UserPointerId.id = payload.reviewFor;
      query.equalTo("reviewFor", UserPointerId);
      query.descending("createdAt");
      query.limit(1000);

      await query
        .find()
        .then(function (response) {
          var avg = 0;
          if (response.length) {
            var sum = 0;
            for (var i = 0; i < response.length; ++i) {
              sum += response[i].get("star");
            }
            avg = sum / response.length;
          }
          return avg;
        })
        .then(function (avg) {
          try {
            const User = Parse.Object.extend("User");
            const saveUser = new User();
            saveUser.id = payload.reviewFor;
            saveUser.set("avgRatings", avg);
            saveUser.save(null, { useMasterKey: true });
            return { status: true, title: "Success", message: "Success" };
          } catch (error) {
            return { status: false, title: "Error", message: error.message };
          }
        })
        .then(function (finalResult) {
          if (finalResult.status) {
            commit("setreviewRatings", true);
          } else {
            commit("setreviewRatings", false);
          }
        })
        .catch(function (error) {
          commit("setreviewRatings", false);
          console.log(JSON.stringify(error));
        });
    } catch (error) {
      console.log(error);
      commit("setreviewRatings", false);
    }
  },

  async getReviewRatings({ commit }, payload) {
    const Reviews = Parse.Object.extend("Reviews");
    const query = new Parse.Query(Reviews);

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.reviewFor;
    query.equalTo("reviewFor", UserPointerId);
    query.include("reviewFrom", "appointmentId");
    query.descending("createdAt");
    query.limit(100);
    try {
      const response = await query.find();
      if (response && response.length > 0) {
        response.sort((a, b) =>
          a.get("appointmentId").get("start") <
          b.get("appointmentId").get("start")
            ? 1
            : -1,
        );
        commit("setGetReview", response);
      } else {
        commit("setGetReview", false);
      }
    } catch (error) {
      console.log(error);
      commit("setGetReview", false);
    }
  },

  async saveTransferQ({ commit }, payload) {
    const Transfers = Parse.Object.extend("transfers");
    const savetransfers = new Transfers();
    /** today + 4 days */
    const maturityDate = new Date(moment().add(4, "days"));
    const Appointments = Parse.Object.extend("Appointments");
    const AppointmentsPointerId = new Appointments();
    AppointmentsPointerId.id = payload.appointmentId;
    savetransfers.set("appointmentId", AppointmentsPointerId);

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.userId;
    savetransfers.set("receiverId", UserPointerId);

    savetransfers.set("ownerAccountId", payload.ownerAccountId);
    savetransfers.set("amount", payload.amount);
    savetransfers.set("maturityDate", maturityDate);
    savetransfers.set("transfer_group", payload.transfer_group);
    savetransfers.set("stripePaymentId", payload.stripePaymentId);
    savetransfers.set("transferred", false);

    try {
      const response = await savetransfers.save();
      commit("setTransferQ", response);
    } catch (error) {
      console.log(error);
      commit("setTransferQ", false);
    }
  },

  async saveApprovedAppointment({ commit }, payload) {
    const Appointments = Parse.Object.extend("Appointments");
    const updateAppointment = new Appointments();
    updateAppointment.id = payload.appointmentId;
    updateAppointment.set("status", payload.status);

    if (payload.bookingLesson) {
      const dateForStartEnd =
        payload.selectedAppointmentDate &&
        moment(payload.selectedAppointmentDate).isValid()
          ? moment(payload.selectedAppointmentDate)
          : payload.appointmentStart
          ? moment(payload.appointmentStart)
          : null;

      if (dateForStartEnd) {
        const start = dateForStartEnd.toDate();
        /** use existing end if provided, otherwise additional 60 mins */
        const end =
          payload.appointmentEnd && moment(payload.appointmentEnd).isValid()
            ? moment(payload.appointmentEnd).toDate()
            : new Date(dateForStartEnd.clone().add(60, "minutes").valueOf());
        updateAppointment.set("start", start);
        updateAppointment.set("end", end);
        updateAppointment.set("drivingLessonDates", []);
      } else {
        updateAppointment.set("drivingLessonDates", []);
      }
    }
    await updateAppointment
      .save()
      .then((response) => {
        commit("setApprovedAppointment", response);
        // store.dispatch('getInstructorAppointments', {
        //   instructorId: store.getters.user.id,
        //   start: start,
        //   end: end
        // });
      })
      .catch((error) => {
        console.log(error);
        commit("setApprovedAppointment", false);
      });
  },

  async getPaymentHistory({ commit }, payload) {
    const PaymentHistories = Parse.Object.extend("PaymentHistories");
    const query = new Parse.Query(PaymentHistories);

    if (payload.userType === "instructor") {
      const User = Parse.Object.extend("User");
      const UserPointerId = new User();
      UserPointerId.id = payload.userId;
      console.log(payload.userId);
      query.equalTo("receiverId", UserPointerId);
    } else {
      const User = Parse.Object.extend("User");
      const UserPointerId = new User();
      UserPointerId.id = payload.userId;
      query.equalTo("senderId", UserPointerId);
    }
    query.include("senderId");
    query.include("receiverId");
    /** let's sort by start date */
    query.descending("paymentDate");
    try {
      const response = await query.find();
      commit("setPaymentHistory", response);
    } catch (error) {
      console.log(error);
      commit("setPaymentHistory", false);
    }
  },

  async getRescheduleFromAdmin({ commit }, payload) {
    const RescheduleBySchools = Parse.Object.extend("RescheduleBySchools");
    const query = new Parse.Query(RescheduleBySchools);

    const User = Parse.Object.extend("User");
    const UserPointerId = new User();
    UserPointerId.id = payload.studentId;
    query.equalTo("studentId", UserPointerId);

    query.include("instructorId");
    query.include("schoolId");
    query.include("studentId");
    /** let's sort by start date */
    query.descending("newDate");
    try {
      const response = await query.find();
      if (typeof response !== "undefined") {
        commit("setRescheduleFromAdmin", response);
      } else {
        commit("setRescheduleFromAdmin", false);
      }
    } catch (error) {
      console.log(error);
      commit("setRescheduleFromAdmin", false);
    }
  },
};

const mutations = {
  setInstructorAppointments: (state, instructorAppointments) =>
    (state.instructorAppointments = instructorAppointments),
  appendInstructorAppointments: (state, newItems) => {
    state.instructorAppointments = (state.instructorAppointments || []).concat(
      newItems,
    );
  },
  setStudentAppointments: (state, studentAppointments) =>
    (state.studentAppointments = studentAppointments),
  appendStudentAppointments: (state, newItems) => {
    state.studentAppointments = (state.studentAppointments || []).concat(newItems);
  },
  setInstructorPackages: (state, instructorPackages) =>
    (state.instructorPackages = instructorPackages),
  setAppointments: (state, appointments) => (state.appointments = appointments),
  setStudentAppointment: (state, studentAppointment) =>
    (state.studentAppointment = studentAppointment),
  setCompleteAppointment: (state, completeAppointment) =>
    (state.completeAppointment = completeAppointment),
  setreviewRatings: (state, reviewRatings) =>
    (state.reviewRatings = reviewRatings),
  setCheckReview: (state, checkReview) => (state.checkReview = checkReview),
  setGetReview: (state, reviews) => (state.reviews = reviews),
  setApprovedAppointment: (state, approveAppointment) =>
    (state.approveAppointment = approveAppointment),
  setTransferQ: (state, transferQ) => (state.transferQ = transferQ),
  setDeclineEvent: (state, declineAppment) =>
    (state.declineAppment = declineAppment),
  setRescheduleEvent: (state, rescheduleAppment) =>
    (state.rescheduleAppment = rescheduleAppment),
  setPaymentHistory: (state, paymentHistory) =>
    (state.paymentHistory = paymentHistory),
  setRescheduleFromAdmin: (state, rescheduleFromAdmin) =>
    (state.rescheduleFromAdmin = rescheduleFromAdmin),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
